module.exports = __webpack_public_path__ + "img/com.codeway.routease-staging.463a8977.png";